import { Injectable } from '@angular/core';
import { RemoteAction } from 'src/app/_model/remote-action/remote-action';
import { Resetable } from '../../resetter/resetable';

/**
 * DataAccessObject for already transmitted remote actions
 */
@Injectable()
export abstract class TransmittedRemoteActionDaoService implements Resetable {
  /**
   * Adds a remote action to the already saved transmitted remote actions
   * @param remoteAction the remote action that should be appended
   */
  public abstract addRemoteAction(remoteAction: RemoteAction): Promise<void>;

  /**
   * Loads all transmitted remote actions from the storage
   * @returns an array of the transmitted remote actions
   */
  public abstract getRemoteActions(): Promise<RemoteAction[]>;

  /**
   * Removes all transmitted remote actions which execution date is older than the actual day
   */
  public abstract purgeRemoteActions(): Promise<void>;

  // Clearable
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
